import React from "react";
import { Typography, Box, Button, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuthStatus } from "./AuthStatusContext";
import LockIcon from "@mui/icons-material/Lock";

/**
 * Unauthorized page shown when a user is authenticated but NOT in the required Cognito group.
 * Provides context, next-steps, and actions (home, logout).
 */
const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuthStatus();

  const handleLogout = async () => {
    await logout();
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" bgcolor="#f5f5f5" px={2}>
      <Paper elevation={3} sx={{ p: 6, maxWidth: 480, textAlign: "center" }}>
        <LockIcon sx={{ fontSize: 56, color: "warning.main" }} />
        <Typography variant="h4" gutterBottom sx={{ mt: 2, fontWeight: 600 }}>
          Access Restricted
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Your account is not currently authorized to use MentoringFusion. Please contact your organization admin to request access.
        </Typography>
        <Typography variant="subtitle1" sx={{ mb: 4 }}>
          Next steps:
        </Typography>
        <Box textAlign="left" sx={{ mb: 4 }}>
          <ul style={{ margin: 0, paddingLeft: "1.2rem" }}>
            <li>Contact your organization admin to request access.</li>
            <li>Or sign in with a different account that has mentoring access.</li>
          </ul>
        </Box>
        <Box display="flex" gap={2} justifyContent="center">
          <Button variant="contained" color="primary" onClick={() => navigate("/")}>Home</Button>
          <Button variant="outlined" color="secondary" onClick={handleLogout}>Sign Out</Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default Unauthorized;
